module.exports = __webpack_public_path__ + "media/configurations/ZOC_X-P-815dbd56.png";